import { Target, Users, TrendingUp, BookOpen, Rocket, Award } from 'lucide-react';

export const benefits = [
  {
    icon: Target,
    title: "Strategia rozwoju",
    description: "Poznasz sprawdzone metody rozwoju szkoły językowej i zwiększania przychodów"
  },
  {
    icon: Users,
    title: "Zarządzanie zespołem",
    description: "Nauczysz się efektywnie zarządzać zespołem lektorów i pracowników"
  },
  {
    icon: TrendingUp,
    title: "Marketing i sprzedaż",
    description: "Zdobędziesz wiedzę jak skutecznie pozyskiwać nowych klientów"
  },
  {
    icon: BookOpen,
    title: "Optymalizacja procesów",
    description: "Usprawnisz działanie szkoły i zautomatyzujesz kluczowe procesy"
  },
  {
    icon: Rocket,
    title: "Rozwój biznesu",
    description: "Poznasz strategie skalowania biznesu i zwiększania rentowności"
  },
  {
    icon: Award,
    title: "Przewaga konkurencyjna",
    description: "Wyróżnisz się na rynku i zbudujesz silną markę szkoły"
  }
] as const;